import PropTypes from 'prop-types';

import { TextImage } from 'Components/TextImage';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const SocialImpactTextImage = ({
  children,
  subTitle,
  title,
  description,
  images,
  imageCaption,
}) => (
  <TextImage
    backgroundColor="noir"
    contentAlignMob="left"
    description={description}
    hasUncroppedMobileImage
    hasWhiteFont
    imageAlt={images.alt}
    imageCaption={imageCaption}
    imageDesktop={images.desktop}
    imageMobile={images.mobile}
    imageMode="contain-desktop"
    subtitle={subTitle}
    subtitleProps={{ style: { fontSize: 18 }, markupName: 'h2' }}
    title={title}
  >
    {children}
  </TextImage>
);

SocialImpactTextImage.propTypes = {
  children: PropTypes.node,
  imageCaption: PropTypes.string,
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.shape({
    alt: PropTypes.string,
    mobile: srcOrNextImageProp,
    desktop: srcOrNextImageProp,
  }).isRequired,
};
SocialImpactTextImage.defaultProps = {
  children: null,
  imageCaption: null,
};

export default SocialImpactTextImage;
